import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// constants
export const TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA =
  'translations-monitoring-alerts/TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA'
export const [
  TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA_SUCCESS,
  TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA_FAILURE,
] = [
  `${TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA}_SUCCESS`,
  `${TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA}_FAILURE`,
]
export const TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA =
  'translations-monitoring-alerts/TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA'
export const [
  TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA_SUCCESS,
  TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA_FAILURE,
] = [
  `${TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA}_SUCCESS`,
  `${TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA}_FAILURE`,
]
export const TRANSLATION_MONITORING_ALERTS_CLEAR_STATE_LIST =
  'translations-monitoring-alerts/TRANSLATION_MONITORING_ALERTS_CLEAR_STATE_LIST'
export const TRANSLATION_MONITORING_ALERTS_CLEAR_STATE_FORM =
  'translations-monitoring-alerts/TRANSLATION_MONITORING_ALERTS_CLEAR_STATE_FORM'
export const TRANSLATION_MONITORING_ALERTS_CLEAR_STATE =
  'translations-monitoring-alerts/CLEAR_STATE'
export const TRANSLATION_MONITORING_ALERTS_CHANGE =
  'translations-monitoring-alerts/TRANSLATION_MONITORING_ALERTS_CHANGE'

// actions
export const translationsMonitoringAlertsFetchTableData = ActionHelper.createActionObj(
  TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA,
)
export const translationsMonitoringAlertsClearStateList = ActionHelper.createActionObj(
  TRANSLATION_MONITORING_ALERTS_CLEAR_STATE_LIST,
)
export const translationsMonitoringAlertsClearState = ActionHelper.createActionObj(
  TRANSLATION_MONITORING_ALERTS_CLEAR_STATE_FORM,
)
export const translationsMonitoringAlertsClearStateForm = ActionHelper.createActionObj(
  TRANSLATION_MONITORING_ALERTS_CLEAR_STATE,
)
export const translationsMonitoringAlertsFetchFormData = ActionHelper.createActionObj(
  TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA,
)
export const translationsMonitoringAlertsChange = ActionHelper.createActionObj(
  TRANSLATION_MONITORING_ALERTS_CHANGE,
)

// store
const initialState = Immutable.fromJS({
  loading: true,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    translations: [],
  },
})
const loadingActive = state => state.set('loading', true)

const jobMonitoringAlertsTranslations = handleActions(
  {
    [combineActions(
      TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA_SUCCESS,
      TRANSLATION_MONITORING_ALERTS_CHANGE,
    )]: loadingActive,
    [combineActions(
      TRANSLATION_MONITORING_ALERTS_CLEAR_STATE,
      RESET_STORE,
    )]: () => initialState,
    [TRANSLATION_MONITORING_ALERTS_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [TRANSLATION_MONITORING_ALERTS_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
  },
  initialState,
)

export default jobMonitoringAlertsTranslations
